import React from 'react';
import {LoadingOutlined} from '@ant-design/icons';

const Item = ({ label, value, loading }) => {
  return (
    <div>
      <div className="gx-mb-2 gx-text-sm gx-text-muted">{label}</div>
      <div className="ant-typography gx-mb-0 gx-text-lg">{loading ? <LoadingOutlined /> : value}</div>
    </div>
  );
}

export default Item;